import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onDragstart", "onDrop"]

import { reactive, ref } from 'vue'
import { istate, eType } from './VDContainer'
/**
 * @description a simple It is used to implement drag and drop
 * functions and provide rich customized content
 * @author Electra_fe
 * -----------------------------------------------------------
 * width:     outer container's width;
 * height:    outer container's height;
 * data:      original array for traversal, Must use array;
 * animation: Boolean;will show animation or not during dnd runtime;
 * type:      [sort|switch] function type of dnd component
 *            sort: default; after dropped,object will insert into target and all elements will sort;
 *            switch: Optional, switch object and target,other elements will stand still;
*/
// eslint-disable-next-line no-undef, no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'VDContainer',
  props: {
    width: null,
    height: null,
    data: null,
    animation: { type: Boolean },
    row: null,
    type: null
  },
  emits: [
  'getData'
],
  setup(__props: any, { emit }) {

const props = __props as {
    width: number,
    height: number,
    data: [],
    animation: boolean,
    row: number,
    type: string,
};



const state: istate = reactive({
  ...props,
  target: 0
})
const getItems = () => props.data
const items = ref(getItems())

// eslint-disable-next-line no-undef

// while target is begin dragged
const drag = (event: DragEvent, index: number) => {
  state.target = index
}

// while target is on the  drop point
const over = (event: DragEvent) => {
  event.preventDefault()
}
// while drop the object into target
const drop = (event: DragEvent, index: number) => {
  if (props.type === eType.SORT) {
    items.value.splice(index, 0, items.value.splice(state.target, 1)[0])
  } else if (props.type === eType.SWITCH) {
    items.value[index] = items.value.splice(state.target, 1, items.value[index])[0]
  } else {
    window.console.error("wrong type name,check <VDContainer></VDContainer>element's [type] modal")
  }
  emit('getData', items.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "vdc-out-container",
    style: _normalizeStyle(`width:${props.width}px`)
  }, [
    _createVNode(_TransitionGroup, {
      name: "fade",
      tag: "div",
      class: "vdc-trans-group-container"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "vdc-item-container",
            draggable: "true",
            key: item,
            onDragstart: ($event: any) => (drag($event, index)),
            onDragover: over,
            onDrop: ($event: any) => (drop($event, index))
          }, [
            _renderSlot(_ctx.$slots, "VDC", {
              data: item,
              index: index
            })
          ], 40, _hoisted_1))
        }), 128))
      ]),
      _: 3
    })
  ], 4))
}
}

})